<div class="p-2 rounded white mt-1 d-flex w-100 align-items-center app-cursor-pointer" (click)="filters.setValue(value)">
  <div class="font-weight-bolder font-small mr-auto">{{ value }}</div>
  <i *ngIf="filters.has(value) ; else not_selected" class="fad fa-{{ include ? 'check' : 'times' }}-circle ml-1 {{ include ? 'green' : 'red' }}-text"></i>
</div>

<ng-template #not_selected>
  <i class="fas fa-circle ml-1 grey-text"></i>
</ng-template>